package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_01_03_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-01-03")
@Composable
public fun Log_2026_01_03(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Art of Circles by Tuesday Sunbottom",
        ogTitle = "The Art of Circles by Tuesday Sunbottom",
        date = LocalDate(2_026, 1, 3),
        aiHint = "Image references 'Duck Song' meme. Title and description reference 'The Art of War' (joke).",
        ogDescription = "“If you know the ‘animate objects’ spell and know yourself, you need not fear the results of a hundred battles.”",
        ogImage = "images/gotAnyGrapes.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A cartoon illustration showing a fairy (Tuesday) talking to a muscular man at a lemonade stand. This is a reference to the meme \"Duck Song\"",
    ) {
        SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
        Log_2026_01_03_Day_1()
        SessionMediaItem(
            image = "images/gotAnyGrapes.webp",
            linkImage = "images/gotAnyGrapes.webp",
            description = "A cartoon illustration showing a fairy (Tuesday) talking to a muscular man at a lemonade stand. This is a reference to the meme \"Duck Song\"",
            width = 1_200,
            height = 630,
        )
    }
}
